export interface PowerLimitationData {
  data: {
    gateway_id: string;
    device_id: string[];
    data: PowerLimitation[];
  };
}

export interface PowerLimitation {
  device_id: string;
  start_datetime: string;
  end_datetime: string;
  control_command: string;
  limitation: string;
  unit: string;
}

export interface PowerLimitationTableList {
  startDate: string;
  startTime: string;
  endDate: string;
  endTime: string;
  controllableDevice: string;
  controlCommand: string;
  limitationValue: string;
}

export enum PowerLimitationControllableDeviceName {
  Hems = 'HEMS',
  VehicleChargingStation = 'Vehicle Charging Station',
}

export interface Filter {
  type: FilterType;
  name: string;
  active: boolean;
}

export enum FilterType {
  Day = 'day',
  Month = 'month',
  Year = 'year',
  Total = 'total',
}

export interface PowerLimitationFilterDateAndType {
  type: FilterType;
  date: moment.Moment;
}

export enum PowerLimitationControlCommandType {
  All = 'all',
  ConsumptionLimitation = 'Consumption Limitation',
  ProductionLimitation = 'Production Limitation',
}
